import { InjectionToken } from "@angular/core";
import { AmiSiteType } from "./ami-site-type.enum";

export const AMI_SITE_TYPE = new InjectionToken<AmiSiteType>('AMI_SITE_TYPE');
